'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'envelope';
var width = 512;
var height = 512;
var aliases = [128386,9993,61443];
var unicode = 'f0e0';
var svgPathData = ['M16 80l0 87.6 240 165 240-165L496 80 16 80zm0 107l0 245 480 0 0-245L256 352 16 187z', 'M16 167.6l240 165 240-165L496 80 16 80l0 87.6zM496 187L256 352 16 187l0 245 480 0 0-245zM0 432L0 176 0 80 0 64l16 0 480 0 16 0 0 16 0 96 0 256 0 16-16 0L16 448 0 448l0-16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEnvelope = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;